module.exports = __webpack_public_path__ + "assets/img/user_achievement_l5.81b19d09.png";